import MonthlyKeywordStore from '@/stores/MonthlyKeywordStore';
import RisingKeywordStore from '@/stores/RisingKeywordStore';
import UIStore from '@/stores/UIStore';
import SEOStore from '@/stores/SEOStore';

class RootStore {
  MonthlyKeywordStore = MonthlyKeywordStore;

  RisingKeywordStore = RisingKeywordStore;

  UIStore = UIStore;

  SEOStore = SEOStore;
}

export default RootStore;
